var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oneClickRecycle"},[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":_vm.recycleBg,"alt":""}})]),_c('bottom-url')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }